module.exports = __webpack_public_path__ + "img/month_back_gray_icon.67ed6fe9.svg";